import { useQuery } from "@faire/web-api--source/api/layout/logged-out-homepage/get-hooks";

export const useBestsellerProductsQuery = () => {
  const { data, isFetching } = useQuery({
    gcTime: Infinity,
    staleTime: Infinity,
  });

  return {
    bestsellerProductsElement: data?.layout_elements?.[0],
    requestId: data?.request_id,
    isFetching,
  };
};
